import * as actionTypes from "./actionTypes"

export function getCardsSuccessful(payload: CardDetails[]) {
    return {
        type: actionTypes.GET_CARDS_SUCCESSFUL,
        payload
    }
}

export function getCardsFailed(payload: any) {
    return {
        type: actionTypes.GET_CARDS_FAILED,
        payload
    }
}

export function makeCardDefaultSuccessful(payload: CardDetails) {
    return {
        type: actionTypes.MAKE_CARD_DEFAULT_SUCCESSFUL,
        payload
    }
}

export function makeCardDefaultFailed() {
    return {
        type: actionTypes.MAKE_CARD_DEFAULT_FAILED
    }
}

export function createCardSuccessful(payload: CreatedCard) {
    return {
        type: actionTypes.CREATE_CARD_SUCCESSFUL,
        payload
    }
}

export function createCardFailed(payload: any) {
    return {
        type: actionTypes.CREATE_CARD_FAILED,
        payload
    }
}

export function deleteCardSuccessful(payload: CardDetails) {
    return {
        type: actionTypes.DELETE_CARD_SUCCESSFUL,
        payload
    }
}

export function deleteCardFailed() {
    return {
        type: actionTypes.DELETE_CARD_FAILED
    }
}